import React, { useEffect } from "react";
import { Col, Form, Input, notification, Row, Select } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { UserServices } from "../../../redux/Services";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { GetLoggedInUser, onlyMobileInput } from "../../../utils";
import HeadingBack from "../../../component/HeadingBack";
import { usePermission } from "../../../hooks/usePermission";
import ChangePassword from "./ChangePassword";
import { UserId } from "../../../utils/";
import {
  onlyAlphaNumericFilter,
  onlyTextandSpaceFilter,
  ValidateEmail,
  ValidatePhone,
} from "../../../utils/validation";
const { Option } = Select;

const EditUser = () => {
  const permission = usePermission("Users Management", "Edit");
  onlyMobileInput();
  const { userId } = useParams();
  let LOG_IN_USER = GetLoggedInUser();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const roleList = useSelector((state) => state.user.roleList || []);
  const userData = useSelector((state) => state.user.userDetail || {});
  console.log("userData", userData);
  const { mutate: fetchRoles } = useMutation((data) =>
    dispatch(UserServices.fetchRolesApi(data, user))
  );
  const { mutate: fetchUserById } = useMutation((data) =>
    dispatch(UserServices.fetchUsersByIdApi(data, userId))
  );
  const { mutate: updateUser } = useMutation((data) =>
    dispatch(UserServices.updateUsersApi(data, userId, navigate))
  );
  const user = {
    UserId: UserId,
  };
  console.log("userId", user);
  useEffect(() => {
    fetchRoles({});
  }, []);

  useEffect(() => {
    if (userId) {
      fetchUserById({ UserId: userId });
    }
  }, [userId]);

  useEffect(() => {
    if (userData && Object.keys(userData)?.length > 0) {
      form.setFieldsValue({
        Name: userData?.Name,
        Mobile: userData?.Mobile,
        Email: userData?.Email,
        RoleId: userData?.RoleId,
        DoctorId: userData?.DoctorId,
        DoctorType: userData?.DoctorType,
        ProfilePhoto: userData?.ProfilePhoto,
      });
    }
  }, [userData]);

  const handleSubmit = (values) => {
    if (userId) {
      let _data = { ...values };
      _data.UserId = LOG_IN_USER?.UserId;
      updateUser(_data);
    }
  };
  // const handleProfileUpload = (e) => {
  //     let file = e.target.files[0];
  //     console.log(file);
  // }
  return (
    <>
      <HeadingBack title={"User Edit"} subHeading="" />
      <div className="p-20">
        <Form
          form={form}
          name="basic"
          layout={"vertical"}
          autoComplete="off"
          onFinish={handleSubmit}
        >
          <Row gutter={[24, 0]}>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Form.Item
                label="Name"
                name="Name"
                rules={[
                  { required: true, message: "Name is required" },
                  { min: 4, message: "Min 4 character required" },
                  { max: 32, message: "Max 32 character allowed" },
                ]}
              >
                <Input
                  autoComplete="new-off"
                  className="form-control"
                  placeholder="Name"
                  onInput={onlyTextandSpaceFilter}
                />
              </Form.Item>
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Form.Item
                label="Mobile"
                name="Mobile"
                rules={[
                  { required: true, message: "Mobile is required" },
                  {
                    validator: ValidatePhone,
                  },
                ]}
              >
                <Input
                  type="text"
                  id="only_mobile"
                  maxLength={10}
                  autoComplete="new-off"
                  className="form-control"
                  placeholder="Mobile"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[24, 0]}>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Form.Item
                label="Email"
                name="Email"
                rules={[
                  { required: true, message: "Email is required" },
                  { validator: ValidateEmail },
                ]}
              >
                <Input
                  autoComplete="new-off"
                  className="form-control"
                  placeholder="Email"
                />
              </Form.Item>
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Form.Item
                label="Role"
                name="RoleId"
                rules={[{ required: true, message: "Role is required" }]}
              >
                <Select
                  className="from-control text-capitalize"
                  placeholder="Select Role"
                  autoComplete="new-off"
                  name="RoleId"
                >
                  <Option className="text-capitalize" value={""}>
                    Select Role
                  </Option>
                  {roleList?.length > 0 &&
                    roleList?.map((item, idx) => (
                      <Option
                        key={idx}
                        className="text-capitalize"
                        value={item.RoleId}
                      >
                        {item.Role}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Form.Item
                label="Doctor Id (In case of Doctor)"
                name="DoctorId"
                rules={[{ required: false, message: "" }]}
              >
                <Input
                  className="form-control"
                  autoComplete="new-off"
                  placeholder="Doctor Id (In case of Doctor)"
                  onInput={onlyAlphaNumericFilter}
                />
              </Form.Item>
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Form.Item
                label="Doctor Type"
                name="DoctorType"
                rules={[{ required: false, message: "" }]}
              >
                <Input
                  className="form-control"
                  autoComplete="new-off"
                  placeholder="Doctor Type"
                  onInput={onlyAlphaNumericFilter}
                />
              </Form.Item>
            </Col>
          </Row>
          {/* <Row gutter={[24, 0]}>
                        <Col lg={12} md={24} sm={24} xs={24}>
                            <Form.Item
                                label="Profile Photo"
                            >
                                <input type="file" name="ProfilePhoto" onChange={(e) => handleProfileUpload(e)} className='form-control' accept='image/*' autoComplete="new-off" />
                            </Form.Item>
                        </Col>
                    </Row> */}
          <div className="text-center">
            <button
              key="submit"
              type="submit"
              className="gradient-button w-auto"
            >
              Update
            </button>
          </div>
        </Form>
      </div>
      <hr></hr>
      <ChangePassword />
    </>
  );
};

export default EditUser;
